import ElementPlus, {
  ElMessage,

} from 'element-plus';

import langEn from 'element-plus/es/locale/lang/en';

const ElementPlusPlugin = {
  install(app, options = {}) {
    app.use(ElementPlus, {
      locale: options.locale || langEn,
    });

    app.config.globalProperties.$message = ElMessage;
  },
};

export default ElementPlusPlugin;
